import { DeepDiveConstants } from './DeepDive.constants';
import moment from 'moment';

const lastFourteenDays = [moment().subtract(14, 'd'), moment().subtract(1, 'd')];
let diff = moment(lastFourteenDays[1]).diff(moment(lastFourteenDays[0]), 'days');

var initialState = {
  marketingDateRange: lastFourteenDays,
  marketingCompareDateRange: [
    moment(lastFourteenDays[0]).subtract(diff + 1, 'd'),
    moment(lastFourteenDays[1]).subtract(diff + 1, 'd')
  ],
  channelList: [],
  childTableData: {},
  updatedFiltersGroup: [],
  allTabsData: {},
  selectedTab: '',
  tabs: {},
  storesCampaignDropdownList: {},
  productDropdownList: [],
  storeGroups: {},
  metricList: {},
  adsTabData: {},
  keywordsTabData: {},
  keywordsTabChildTableData: {},
  creativesTabData: {},
  storesTabData: {},
  storesTabChildTableData: {},
  mediaChannelsTabData: {},
  mediaChannelsTabChildTableData: {},
  campaignTypeTabData: {},
  campaignTypeTabChildTableData: {},
  selectedStores: {},
  view: 'default',
  metricDefinition: {},
  preferredColumns: {},
  currentTabs: { topCurrentTab: { tab: 'channels' }, bottomCurrentTab: { tab: 'ads_breakdown' } },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DeepDiveConstants.GET_DEEP_DIVE_DATA_REQUEST:
      return {
        ...state,
        comparisonData: { loading: true, error: false }
      };

    case DeepDiveConstants.GET_DEEP_DIVE_DATA_SUCCESS:
      return {
        ...state,
        comparisonData: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case DeepDiveConstants.GET_DEEP_DIVE_DATA_FAILED:
      return {
        ...state,
        comparisonData: { loading: false, error: true }
      };

    // --- Metric list
    case DeepDiveConstants.GET_METRIC_LIST_REQUEST:
      return {
        ...state,
        metricList: { loading: true, error: false }
      };

    case DeepDiveConstants.GET_METRIC_LIST_SUCCESS:
      return {
        ...state,
        metricList: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case DeepDiveConstants.GET_METRIC_LIST_FAILED:
      return {
        ...state,
        metricList: { loading: false, error: true }
      };

    // --- stores campaign deropdown list
    case DeepDiveConstants.GET_STORESC_CAMPAIGN_DROPDOWN_REQUEST:
      return {
        ...state,
        storesCampaignDropdownList: {}
      };

    case DeepDiveConstants.GET_STORESC_CAMPAIGN_DROPDOWN_SUCCESS:
      return {
        ...state,
        storesCampaignDropdownList: { ...action.payload }
      };

    case DeepDiveConstants.GET_STORESC_CAMPAIGN_DROPDOWN_FAILED:
      return {
        ...state,
        storesCampaignDropdownList: {}
      };

    // ---product dropdown list
    case DeepDiveConstants.GET_PRODUCT_DROPDOWN_REQUEST:
      return {
        ...state,
        productDropdownList: []
      };

    case DeepDiveConstants.GET_PRODUCT_DROPDOWN_SUCCESS:
      return {
        ...state,
        productDropdownList: [...action.payload]
      };

    case DeepDiveConstants.GET_PRODUCT_DROPDOWN_FAILED:
      return {
        ...state,
        productDropdownList: []
      };

    // --- Marketing deep dive keywords child table data
    case DeepDiveConstants.GET_KEYWORDS_CHILD_TABLE_DATA:
      return {
        ...state,
        keywordsTabChildTableData: { ...action.payload }
      };

    case DeepDiveConstants.GET_STORES_DATA:
      return {
        ...state,
        storesTabData: { ...action.payload }
      };

    case DeepDiveConstants.GET_STORES_CHILD_TABLE_DATA:
      return {
        ...state,
        storesTabChildTableData: { ...action.payload }
      };

    case DeepDiveConstants.GET_MEDIA_CHANNELS_DATA:
      return {
        ...state,
        mediaChannelsTabData: { ...action.payload }
      };

    case DeepDiveConstants.GET_MEDIA_CHANNELS_CHILD_TABLE_DATA:
      return {
        ...state,
        mediaChannelsTabChildTableData: { ...action.payload }
      };

    case DeepDiveConstants.GET_PRODUCT_TABLE_DATA:
      return {
        ...state,
        productTabData: { ...action.payload }
      };

    case DeepDiveConstants.GET_PRODUCT_CHILD_TABLE_DATA:
      return {
        ...state,
        productTabChildTableData: { ...action.payload }
      };

    // --- Marketing deep dive data
    case DeepDiveConstants.GET_ADS_DATA:
      return {
        ...state,
        adsTabData: { ...action.payload }
      };

    case DeepDiveConstants.GET_KEYWORDS_DATA:
      return {
        ...state,
        keywordsTabData: { ...action.payload }
      };

    case DeepDiveConstants.GET_CREATIVES_DATA:
      return {
        ...state,
        creativesTabData: { ...action.payload }
      };
    // --- Marketing deep dive data

    case DeepDiveConstants.GET_CHANNEL_LIST:
      return {
        ...state,
        channelList: action.payload
      };

    case DeepDiveConstants.GET_CHILD_TABLE_TOP_RECORD:
      return {
        ...state,
        childTableData: { ...state.childTableData, ...action.payload }
      };

    case DeepDiveConstants.UPDATE_FILTER_GROUP:
      return {
        ...state,
        updatedFiltersGroup: [...state.updatedFiltersGroup, action.payload]
      };

    // --- update object
    case DeepDiveConstants.UPDATE_ENTIRE_FILTER:
      return {
        ...state,
        updatedFiltersGroup: action.payload
      };

    // --- update object
    case DeepDiveConstants.UPDATE_TEST:
      return {
        ...state,
        allTabsData: action.payload
      };

    // --- update object
    case DeepDiveConstants.UPDATE_ANY:
      return {
        ...state,
        ...action.payload
      };

    // --- update Selected tab
    case DeepDiveConstants.UPDATE_TAB:
      return {
        ...state,
        selectedTab: action.payload
      };

    // --- get tabs from API

    case DeepDiveConstants.GET_DEEP_DIVE_TABS_REQUEST:
      return {
        ...state,
        tabs: { loading: true, error: false }
      };

    case DeepDiveConstants.GET_DEEP_DIVE_TABS_SUCCESS:
      return {
        ...state,
        tabs: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case DeepDiveConstants.GET_DEEP_DIVE_TABS_FAILED:
      return {
        ...state,
        tabs: { loading: false, error: true }
      };

    case DeepDiveConstants.UPDATE_STORE_GROUPS:
      return {
        ...state,
        storeGroups: action.payload
      };

    case DeepDiveConstants.ACTIVE_TAB_ID_UPDATE:
      return {
        ...state,
        selectedTab: action.payload
      };

    case DeepDiveConstants.UPDATE_SELECTED_STORES:
      return {
        ...state,
        selectedStores: action.payload
      };

    case DeepDiveConstants.CHANGE_VIEW:
      return {
        ...state,
        view: action.payload
      };

    case DeepDiveConstants.GET_METRIC_DEFINITION_REQUEST:
      return {
        ...state,
        metricDefinition: {
          loading: true,
          error: false
        }
      };

    case DeepDiveConstants.GET_METRIC_DEFINITION_SUCCESS:
      return {
        ...state,
        metricDefinition: { loading: false, error: false, data: action.payload }
      };

    case DeepDiveConstants.GET_METRIC_DEFINITION_FAILED:
      return {
        ...state,
        metricDefinition: { loading: false, error: true }
      };

    case DeepDiveConstants.GET_PREFERRED_COLUMN_REQUEST:
      return {
        ...state,
        preferredColumns: {
          loading: true,
          error: false
        }
      };

    case DeepDiveConstants.GET_PREFERRED_COLUMN_SUCCESS:
      return {
        ...state,
        preferredColumns: action.payload
      };

    case DeepDiveConstants.GET_PREFERRED_COLUMN_FAILED:
      return {
        ...state,
        preferredColumns: {
          loading: false,
          error: true
        }
      };

    case DeepDiveConstants.CURRENT_TABS:
      return {
        ...state,
        currentTabs: action.payload
      };

  

    default:
      return state;
  }
}
